import baseReducer from '@utilities/base-reducer'
import * as Actions from './legal-responsible-step-action'

const initialState = {
  fullName: '',
  cpf: '',
  cellPhone: '',
  email: '',
}

const onboardingReducer = baseReducer(initialState, {
  [Actions.SET_LEGAL_RESPONSIBLE_FIELD](state, { payload: { name, value } }) {
    return { ...state, [name]: value }
  },
})

export default onboardingReducer
